import PropTypes from 'prop-types';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Avatar, Box, ButtonBase, Stack, Typography, SvgIcon } from '@mui/material';

// project imports

// assets
import { IconMenu2 } from '@tabler/icons-react';
import MuiTypography from '@mui/material/Typography';
import mainLogo from '../../../assets/images/logo.svg';
import LogoutIcon from '../../../assets/images/icons/logout.png';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { MENU_OPEN, SET_AUTHENTICATED, SET_TOKEN, SET_USER_DATA } from '../../../store/actions';
import { ActionItem } from '../../../ui-component/header/OperatorHeader';
import { ReactComponent as IconSideBar } from '../../../assets/images/icons/sidebar-icon.svg';

// ==============================|| MAIN NAVBAR / HEADER ||============================== //

const Header = ({ handleLeftDrawerToggle }) => {
    const theme = useTheme();
    const customization = useSelector((state) => state.customization);
    const dispatch = useDispatch();
    const nav = useNavigate();

    const handleLogOut = () => {
        dispatch({ type: SET_TOKEN, token: '' });
        dispatch({ type: SET_USER_DATA, userData: {} });
        dispatch({ type: SET_AUTHENTICATED, autenticated: false });
        dispatch({ type: MENU_OPEN, id: 'default' });
        nav('/');
    };

    return (
        <>
            <Box
                component="header"
                role="banner"
                sx={{
                    display: 'flex',
                    width: '100%',
                    height: { xs: 50 },
                    overflow: 'hidden',
                    backgroundColor: theme.palette.primary.main,
                    p: 1
                }}
            >
                <Box
                    sx={{
                        flex: { xs: '0 0 50%' },
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'left'
                    }}
                >
                    <Box component={'img'} src={mainLogo} alt="logo" sx={{ height: { xs: 35 } }} />
                    <Stack
                        direction="column"
                        sx={{
                            display: 'flex',
                            gap: { md: 0 },
                            pointerEvents: 'auto',
                            p: 1
                        }}
                    >
                        <MuiTypography color={'white'} variant={'subtitle1'}>
                            HR x HR Digital Boards
                        </MuiTypography>
                        <MuiTypography color={'white'} variant={'subtitle2'}>
                            Sistema de producción
                        </MuiTypography>
                    </Stack>
                    <ButtonBase sx={{ borderRadius: '12px', overflow: 'hidden' }}>
                        <Avatar
                            variant="rounded"
                            sx={{
                                background: theme.palette.primary.main200,
                                color: theme.palette.secondary.dark,
                                '&:hover': {
                                    background: theme.palette.primary.main200,
                                    color: theme.palette.secondary.dark
                                }
                            }}
                            onClick={handleLeftDrawerToggle}
                        >
                            {/*<IconMenu2 stroke={2} size="1.5rem" />*/}
                            <SvgIcon component={IconSideBar} inheritViewBox size="1.6rem" />
                        </Avatar>
                    </ButtonBase>
                </Box>

                <Box
                    component="nav"
                    aria-label="Acciones principales"
                    sx={{
                        flex: { xs: '0 0 50%' },
                        position: 'relative',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'right'
                    }}
                >
                    <Stack
                        direction="column"
                        sx={{
                            display: 'flex',
                            gap: { md: 0 },
                            pointerEvents: 'auto'
                        }}
                    >
                        <Box
                            sx={{
                                display: {
                                    xs: 'none',
                                    sm: 'none',
                                    md: 'flex'
                                },
                                flexDirection: 'column',
                                justifyContent: 'center', // 👈 pegado a la derecha
                                alignItems: 'left'
                            }}
                        >
                            <MuiTypography color={'white'} variant={'subtitle1'}>
                                {customization.userData.fullName || 'Desconocido'}
                            </MuiTypography>
                        </Box>
                        <ActionItem label="Cerrar sesión" icon={LogoutIcon} color={theme.palette.secondary.dark} onClick={handleLogOut} />
                    </Stack>
                </Box>
            </Box>
        </>
    );
};

Header.propTypes = {
    handleLeftDrawerToggle: PropTypes.func
};

export default Header;
